import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import error from './error'
import helpers from './helpers'
import searchParams from './searchParams'
import huggy from './huggy'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    error,
    helpers,
    searchParams,
    huggy
  }
})
